import { Title, Button, RadioSelect, Text } from 'components';
import { PriceBreakDownSummary } from 'components/PriceBreakDownSummary';
import { BottomBar, Container, Picker } from './PaymentModePicker.style';
import { usePaymentModeVM } from './usePaymentModePickerVm';
import { PaymentMode } from '../usePaymentVm';

type Props = {
    paymentMode: PaymentMode;
    handlePaymentModeConfirm: () => void;
    handlePaymentModeChange: (mode: PaymentMode) => void;
};

const PaymentModePicker: React.FunctionComponent<Props> = ({
    paymentMode,
    handlePaymentModeConfirm,
    handlePaymentModeChange,
}) => {
    const { currency, totalPriceBreakdown, canPay, amountWithCurrency, paymentMethodOptions } =
        usePaymentModeVM();

    return (
        <Container>
            <Picker>
                <Title text="payment_mode" weight="bold" />
                <RadioSelect
                    options={paymentMethodOptions}
                    selected={paymentMode || paymentMethodOptions[0]}
                    onChange={handlePaymentModeChange}
                />
            </Picker>
            <div>
                {currency && totalPriceBreakdown && (
                    <PriceBreakDownSummary currency={currency} {...totalPriceBreakdown} />
                )}
                <BottomBar>
                    <Button
                        fullWidth
                        isSubmit
                        onClick={handlePaymentModeConfirm}
                        disabled={!canPay}
                    >
                        <Text
                            text={'button_pay'}
                            values={{
                                amount: amountWithCurrency,
                            }}
                            weight="bold"
                        />
                    </Button>
                </BottomBar>
            </div>
        </Container>
    );
};

export default PaymentModePicker;
